import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import Page from 'src/components/page/page';
import TableRox from 'src/components/table-rox/TableRox';
import useBanners from './banners.hook';
import { paths } from 'src/routes/paths';

export default function Banners() {
  const { TABLEHEADER, isLoadingBannersList, bannersList, navigate } = useBanners();
  return (
    <Page title="Lista de Banners">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs heading="Lista de Banners" links={[]} />
        {isLoadingBannersList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            header={TABLEHEADER}
            data={bannersList}
            defaultOrderBy="name"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => navigate(paths.dashboard.bannerDetails(id))}
            avatarType="default"
            avatarKey="url"
          />
        )}
      </Container>
    </Page>
  );
}
